import type { CookieService } from "@/src/infrastructure/cookieconsent/CookieService";

export function cookieLabel({
  name,
  privacyPolicyUrl,
  purpose,
}: CookieService): string {
  const lines = [
    `<h4 style="font-size: 1.1em; font-weight: bold;">${name}</h4>`,
    `<p>${purpose}</p>`,
    privacyPolicyUrl
      ? `<p><a href="${privacyPolicyUrl}">Politique de confidentialité</a></p>`
      : null,
  ].filter((line) => line !== null);
  return `<div style="margin: 0.1em 0 0.1em 0; display: flex; flex-direction: column; gap: 0.1em;">${lines.join("")}</div>`;
}
